import { render, staticRenderFns } from "./editResultado.vue?vue&type=template&id=2fb38151&scoped=true&"
import script from "./editResultado.vue?vue&type=script&lang=js&"
export * from "./editResultado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb38151",
  null
  
)

export default component.exports